import script from "./SignUpDonePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpDonePage.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpDonePage.vue?vue&type=style&index=0&id=15fd0d86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15fd0d86"]])

export default __exports__